<template>
    <a-drawer title="意向客户列表" :visible="visible" :wrap-class-name="drawerWrapClassName" destroy-on-close
              :mask-closable="false" @close="onClose" width="65%">
        <div class="ant-drawer-main">
            <a-table
                :columns="columns"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :pagination="pagination"
                :data-source="dataSource"
                :loading="loading"
                @change="onTableChange">
                <template #abutmentType="{text}">
                    <a-tag>
                        <dict-render :dict-obj="dictObjs['abutment_type']" :text="text"></dict-render>
                    </a-tag>
                </template>
                <template #transactionStatus="{text}">
                    <a-tag>
                        <dict-render :dict-obj="dictObjs['intention_transaction_status']" :text="text"></dict-render>
                    </a-tag>
                </template>
                <template #action="{record}">
                    <div class="table-row-operations">
                        <a @click="onButt(record)" v-if="record.transactionStatus == '0'">确认交易</a>
                        <a v-else style="pointer-events:none;color:#c4cbcf">确认交易</a>
                    </div>

                </template>
            </a-table>
        </div>
    </a-drawer>
</template>
<script>
    import {formMixin, dictMixin, tableListMixin} from "@/mixins";
    import {tradeApi} from "@/api/knowledge";
    import DictRender from "@/components/other/DictRender";

    const columns = [
        // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
        {title: "意向客户名称", dataIndex: "userName", key: "userName"},
        {title: "意向客户类型", dataIndex: "userType", key: "userType", slots: {customRender: "abutmentType"}},
        {title: "交易状态", dataIndex: "transactionStatus", key: "transactionStatus", slots: {customRender: "transactionStatus"}},
        {title: "联系电话", dataIndex: "phone", key: "phone"},
        {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
    ];

    export default {
        name: "CompanyAbutmentListModal",
        mixins: [formMixin, dictMixin, tableListMixin],
        components: {DictRender},
        props: {transactionId: String},
        data() {
            return {
                dictNames: 'need_status,abutment_type,intention_transaction_status',
                columns,
                queryParamFixed: {
                },
                listUrl: tradeApi.pageListIntention,
                listKeyField: "id",
            }
        },
        watch: {
            transactionId() {
                this.queryParam.transactionId=this.transactionId
                this.loadData(1)
            }
        },

        methods: {
            onButt(record) {
                this.postAction({
                    url: tradeApi.affirm,
                    params: {
                        id: record.id,
                    }
                }).then(res => {
                    console.log(res, 'res')
                    
                    this.$notification.success({
                                message: '交易成功',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                })

            },
            onClose() {
                this.visible = false
                this.$emit("onCloseModel")
            }
        }
    }
</script>
